<template>
  <div class="it-footer-main">
    <div class="container">
      <section>
        <div class="row clearfix">
          <div class="col-sm-12">
            <div class="it-brand-wrapper">
              <a href="#">
                <img id="unibo-logo-footer" src="static/logo.svg" alt="Torna alla pagina iniziale">
                <div class="it-brand-text">
                  <h2 class="no_toc">CIRSFID, ALMA MATER STUDIORUM - Università di Bologna</h2>
                  <h3 class="no_toc d-none d-md-block">
                    Portali per la visualizzazione di documenti giuridici
                  </h3>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    <!--  <section>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 pb-2">
            <h4>
              <a href="#" title="Vai alla pagina: Amministrazione">Amministrazione</a>
            </h4>
            <div class="link-list-wrapper">
              <ul class="footer-list link-list clearfix">
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Giunta e consiglio">Giunta e consiglio</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Aree di competenza">Aree di competenza</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Dipendenti">Dipendenti</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Luoghi">Luoghi</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Associazioni e società partecipate">Associazioni e società partecipate</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 pb-2">
            <h4>
              <a href="#" title="Vai alla pagina: Servizi">Servizi</a>
            </h4>
            <div class="link-list-wrapper">
              <ul class="footer-list link-list clearfix">
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Pagamenti">Pagamenti</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Sostegno">Sostegno</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Domande e iscrizioni">Domande e iscrizioni</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Segnalazioni">Segnalazioni</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Autorizzazioni e concessioni">Autorizzazioni e concessioni</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Certificati e dichiarazioni">Certificati e dichiarazioni</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 pb-2">
            <h4>
              <a href="#" title="Vai alla pagina: Novità">Novità</a>
            </h4>
            <div class="link-list-wrapper">
              <ul class="footer-list link-list clearfix">
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Notizie">Notizie</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Eventi">Eventi</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Comunicati stampa">Comunicati stampa</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6">
            <h4>
              <a href="#" title="Vai alla pagina: Documenti">Documenti</a>
            </h4>
            <div class="link-list-wrapper">
              <ul class="footer-list link-list clearfix">
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Progetti e attività">Progetti e attività</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Delibere, determine e ordinanze">Delibere, determine e ordinanze</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Bandi">Bandi</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Concorsi">Concorsi</a>
                </li>
                <li>
                  <a class="list-item" href="#" title="Vai alla pagina: Albo pretorio">Albo pretorio</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section> -->
      <section class="py-4 border-white border-top">
        <div class="row">
          <div class="col-lg-6 col-md-6 pb-1">
            <h4>
              <a href="#" title="Vai alla pagina: Amministrazione">Amministrazione trasparente</a>
            </h4>
            <p>
              I dati personali pubblicati sono riutilizzabili solo alle
              condizioni previste dalla direttiva comunitaria 2003/98/CE e dal
              d.lgs. 36/2006
            </p>
          </div>
          <div class="col-lg-6 col-md-6 pb-1">
            <h4>
              <a href="#" title="Vai alla pagina: Contatti">Contatti</a>
            </h4>
            <p>
              <strong>Luca Cevone, Monica Palmirani</strong><br>
              CIRSFID, Via Galliera 3, 40122 Bologna
            </p>
            <div class="link-list-wrapper">
              <ul class="footer-list link-list clearfix">
                <li>
                  <a class="list-item" href="mailto:luca.cervone@unibo.it" title="Mail a: Luca Cervone">luca.cervone@unibo.it</a>
                </li>
                <li>
                  <a class="list-item" href="mailto:monica.palmirani@unibo.it" title="Mail a: Monica Palmirani">monica.palmirani@unibo.it</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- div class="col-lg-3 col-md-3 pb-2">
            <h4>
              <a href="#" title="Vai alla pagina: Newsletter">Newsletter</a>
            </h4>
            <form action="#" class="form-newsletter" method="post">
              <label class="text-white font-weight-semibold active" for="input-newsletter" style="transition: none 0s ease 0s;">Iscriviti per riceverla</label>
              <input class="form-control" id="input-newsletter" name="input-newsletter" placeholder="mail@example.com" type="email">
              <button class="btn btn-primary btn-icon" type="submit">
                <svg class="icon icon-white">
                  <use :xlink:href="icons.itMail"></use>
                </svg>
                <span>Iscriviti</span>
              </button>
            </form>
          </div>
          <div class="col-lg-3 col-md-3 pb-2">
            <h4>
              <a href="#" title="Vai alla pagina: Seguici su">Seguici su</a>
            </h4>
            <ul class="list-inline text-left social">
              <li class="list-inline-item">
                <a class="p-2 text-white" href="#" target="_blank">
                  <svg class="icon icon-sm icon-white align-top">
                    <use :xlink:href="icons.itDesignersItalia"></use>
                  </svg>
                  <span class="sr-only">Designers Italia</span></a>
              </li>
              <li class="list-inline-item">
                <a class="p-2 text-white" href="#" target="_blank">
                  <svg class="icon icon-sm icon-white align-top">
                    <use :xlink:href="icons.itTwitter"></use>
                  </svg>
                  <span class="sr-only">Twitter</span></a>
              </li>
              <li class="list-inline-item">
                <a class="p-2 text-white" href="#" target="_blank">
                  <svg class="icon icon-sm icon-white align-top">
                    <use :xlink:href="icons.itMedium"></use>
                  </svg>
                  <span class="sr-only">Medium</span></a>
              </li>
            </ul>
          </div> -->
        </div>
      </section>
    </div>
  </div>
</template>


<script>
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'FooterTop',
  data() {
    return {
      icons: {
        itDesignersItalia: `${sprites}#it-designers-italia`,
        itTwitter: `${sprites}#it-twitter`,
        itMedium: `${sprites}#it-medium`,
        itGithub: `${sprites}#it-github`,
        itMail: `${sprites}#it-mail`,
        itBurger: `${sprites}#it-burger`,
      },
    };
  },
  components: {
  },
};
</script>

<style lang="less" scoped>
  #unibo-logo-footer{
    width:5em;
    margin-right:5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/footer/FooterTop.vue